var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.09 22.91c.48 0 .9-.17 1.23-.51.34-.34.51-.75.51-1.24 0-.48-.17-.9-.5-1.23a1.68 1.68 0 0 0-1.24-.51c-.49 0-.9.17-1.24.5-.34.35-.51.76-.51 1.24 0 .49.17.9.51 1.24.34.34.75.51 1.24.51zm4.08-1.75c0 1.13-.4 2.1-1.19 2.9-.8.8-1.76 1.2-2.9 1.2-1.12 0-2.08-.4-2.88-1.2-.8-.8-1.2-1.77-1.2-2.9 0-1.12.4-2.09 1.2-2.89.8-.8 1.76-1.2 2.89-1.2 1.12 0 2.09.4 2.89 1.2.8.8 1.2 1.77 1.2 2.9zm8.34 8c0-.48-.17-.9-.5-1.23a1.68 1.68 0 0 0-1.24-.51c-.49 0-.9.17-1.24.5-.34.35-.51.76-.51 1.24 0 .49.17.9.51 1.24.34.34.75.5 1.24.5.48 0 .9-.16 1.23-.5.34-.34.51-.75.51-1.24zm2.34 0c0 1.13-.4 2.1-1.2 2.9-.8.79-1.76 1.19-2.88 1.19-1.13 0-2.1-.4-2.9-1.2-.8-.8-1.2-1.76-1.2-2.89 0-1.13.4-2.1 1.2-2.9.8-.79 1.77-1.19 2.9-1.19 1.12 0 2.09.4 2.89 1.2.8.8 1.2 1.76 1.2 2.9zM29.02 17h1.67L21.8 33.35h-1.7L29 17z",
    fill: "#FFF"
  })));
});